import { EventEmitter, Injectable } from '@angular/core';
import { Toast } from 'server/shared/models/toast';
import { randomId } from 'server/shared/helpers/random';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public toastAdded$: EventEmitter<Toast>;

  constructor() {
    this.toastAdded$ = new EventEmitter<Toast>();
  }

  public add(toast: Toast): void {
    toast.id = toast.id ? toast.id : randomId();
    this.toastAdded$.emit(toast);
  }

  makeServerErrorToast() {
    this.add({
      type: 'ERROR',
      message: 'serverError',
      timeout: 10000,
    });
  }
}
